<div class="ap-page">

  <!-- ── Page header ──────────────────────────────────────────── -->
  <div class="ap-header">
    <div class="ap-header__left">
      <div class="ap-header__icon">
        <mat-icon>event_note</mat-icon>
      </div>
      <div>
        <h1 class="ap-header__title">Asuntos propios</h1>
        <p class="ap-header__sub">Gestiona las solicitudes y aprobaciones de asuntos propios del equipo</p>
      </div>
    </div>
    <div class="ap-header__actions">
      <button mat-flat-button class="ap-btn-primary" (click)="create()">
        <mat-icon>add</mat-icon> Nuevo asunto propio
      </button>
      <app-help key="Personal4"></app-help>
    </div>
  </div>

  <!-- ── Loading ──────────────────────────────────────────────── -->
  <div class="ap-loading" *ngIf="(AsuntosPropiosService.loading$ | async)">
    <div class="ap-loading__icon-wrap"><mat-icon>event_note</mat-icon></div>
    <div class="ap-loading__dots"><span></span><span></span><span></span></div>
    <p class="ap-loading__text">Cargando asuntos propios…</p>
  </div>

  <ng-container *ngIf="!(AsuntosPropiosService.loading$ | async)">

    <!-- ── Sección: Solicitudes pendientes ────────────────────── -->
    <div class="ap-section">
      <div class="ap-section__head">
        <span class="ap-pill ap-pill--pending"></span>
        <div>
          <h2 class="ap-section__title">Solicitudes pendientes</h2>
          <p class="ap-section__sub">Solicitudes realizadas por los empleados que están a la espera de aprobación</p>
        </div>
      </div>

      <div class="ap-empty"
           *ngIf="(asuntosPropiosSolicitados$ | async)?.length === 0">
        <div class="ap-empty__art"><mat-icon>event_available</mat-icon></div>
        <h3 class="ap-empty__title">Sin solicitudes pendientes</h3>
        <p class="ap-empty__sub">No hay solicitudes de asuntos propios esperando aprobación.</p>
      </div>

      <div class="ap-card" *ngIf="(asuntosPropiosSolicitados$ | async)?.length > 0">
        <table mat-table [dataSource]="asuntosPropiosSolicitados$ | async" matSort class="ap-table">

          <ng-container matColumnDef="employee">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Empleado</th>
            <td mat-cell *matCellDef="let el">
              <div class="ap-cell-employee">
                <div class="ap-avatar">{{ nombreEmpleado(el.employees_Id) | slice:0:1 }}</div>
                <span>{{ nombreEmpleado(el.employees_Id) }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="cadenaInicio">
            <th mat-header-cell *matHeaderCellDef>Inicio</th>
            <td mat-cell *matCellDef="let el"><span class="ap-date">{{ el.cadenaInicio }}</span></td>
          </ng-container>

          <ng-container matColumnDef="cadenaFin">
            <th mat-header-cell *matHeaderCellDef>Fin</th>
            <td mat-cell *matCellDef="let el"><span class="ap-date">{{ el.cadenaFin }}</span></td>
          </ng-container>

          <ng-container matColumnDef="motivo">
            <th mat-header-cell *matHeaderCellDef>Motivo</th>
            <td mat-cell *matCellDef="let el">{{ el.motivo || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="cadenaFechaSolicitud">
            <th mat-header-cell *matHeaderCellDef>Solicitud</th>
            <td mat-cell *matCellDef="let el"><span class="ap-date">{{ el.cadenaFechaSolicitud }}</span></td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef class="ap-col-actions"></th>
            <td mat-cell *matCellDef="let el" class="ap-col-actions">
              <button mat-icon-button [matMenuTriggerFor]="menuSolicitados" (click)="setRow(el)"
                      class="ap-menu-trigger" matTooltip="Acciones">
                <mat-icon>more_vert</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let r; columns: displayedColumns;" class="ap-row"></tr>
        </table>
      </div>
    </div>

    <!-- ── Sección: Asuntos propios aprobados ─────────────────── -->
    <div class="ap-section">
      <div class="ap-section__head">
        <span class="ap-pill ap-pill--approved"></span>
        <div>
          <h2 class="ap-section__title">Asuntos propios aprobados</h2>
          <p class="ap-section__sub">Solicitudes ya aprobadas. Los creados desde aquí quedan aprobados automáticamente</p>
        </div>
      </div>

      <div class="ap-empty"
           *ngIf="(asuntosPropiosAprobados$ | async)?.length === 0">
        <div class="ap-empty__art"><mat-icon>check_circle</mat-icon></div>
        <h3 class="ap-empty__title">Sin asuntos propios aprobados</h3>
        <p class="ap-empty__sub">Aún no se ha aprobado ninguna solicitud de asuntos propios.</p>
      </div>

      <div class="ap-card" *ngIf="(asuntosPropiosAprobados$ | async)?.length > 0">
        <table mat-table [dataSource]="asuntosPropiosAprobados$ | async" matSort class="ap-table">

          <ng-container matColumnDef="employee">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Empleado</th>
            <td mat-cell *matCellDef="let el">
              <div class="ap-cell-employee">
                <div class="ap-avatar">{{ nombreEmpleado(el.employees_Id) | slice:0:1 }}</div>
                <span>{{ nombreEmpleado(el.employees_Id) }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="cadenaInicio">
            <th mat-header-cell *matHeaderCellDef>Inicio</th>
            <td mat-cell *matCellDef="let el"><span class="ap-date">{{ el.cadenaInicio }}</span></td>
          </ng-container>

          <ng-container matColumnDef="cadenaFin">
            <th mat-header-cell *matHeaderCellDef>Fin</th>
            <td mat-cell *matCellDef="let el"><span class="ap-date">{{ el.cadenaFin }}</span></td>
          </ng-container>

          <ng-container matColumnDef="motivo">
            <th mat-header-cell *matHeaderCellDef>Motivo</th>
            <td mat-cell *matCellDef="let el">{{ el.motivo || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="cadenaFechaSolicitud">
            <th mat-header-cell *matHeaderCellDef>Solicitud</th>
            <td mat-cell *matCellDef="let el"><span class="ap-date">{{ el.cadenaFechaSolicitud }}</span></td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef class="ap-col-actions"></th>
            <td mat-cell *matCellDef="let el" class="ap-col-actions">
              <button mat-icon-button [matMenuTriggerFor]="menuAprobados" (click)="setRow(el)"
                      class="ap-menu-trigger" matTooltip="Acciones">
                <mat-icon>more_vert</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let r; columns: displayedColumns;" class="ap-row"></tr>
        </table>
      </div>
    </div>

    <!-- ── Sección: Por empleado ──────────────────────────────── -->
    <div class="ap-section">
      <div class="ap-section__head">
        <span class="ap-pill ap-pill--search"></span>
        <div>
          <h2 class="ap-section__title">Historial por empleado</h2>
          <p class="ap-section__sub">Consulta todos los asuntos propios de un empleado concreto, con su estado</p>
        </div>
      </div>

      <!-- Filtro -->
      <div class="ap-filter-card" *ngIf="formBusqueda !== null && empleados?.length > 0">
        <div class="ap-filter-card__head">
          <mat-icon class="ap-filter-card__icon">search</mat-icon>
          <span>Buscar por empleado</span>
        </div>
        <form [formGroup]="formBusqueda" class="ap-filter-form">
          <mat-form-field appearance="outline" class="ap-filter-field">
            <mat-label>Empleado</mat-label>
            <mat-select formControlName="employees_Id">
              <mat-option *ngFor="let e of empleados; trackBy: trackByIndex" [value]="e.uid">
                {{ e.name }}
              </mat-option>
            </mat-select>
            <mat-hint>Selecciona el empleado para ver su historial de asuntos propios</mat-hint>
            <mat-error *ngIf="formBusqueda.controls['employees_Id'].hasError('required')">
              El empleado es <strong>obligatorio</strong>
            </mat-error>
          </mat-form-field>
          <div class="ap-filter-actions">
            <button mat-flat-button class="ap-btn-primary" type="button"
                    (click)="obtenerAsuntosPropiosPorEmpleado()">
              <mat-icon>search</mat-icon> Buscar
            </button>
            <button mat-stroked-button class="ap-btn-ghost" type="button" (click)="cancelar()"
                    *ngIf="asuntosPropiosPorEmpleado?.length > 0">
              <mat-icon>close</mat-icon> Limpiar
            </button>
          </div>
        </form>
      </div>

      <!-- Resultados -->
      <div class="ap-card" *ngIf="asuntosPropiosPorEmpleado?.length > 0">
        <table mat-table [dataSource]="asuntosPropiosPorEmpleado" matSort class="ap-table">

          <ng-container matColumnDef="cadenaInicio">
            <th mat-header-cell *matHeaderCellDef>Inicio</th>
            <td mat-cell *matCellDef="let el"><span class="ap-date">{{ el.cadenaInicio }}</span></td>
          </ng-container>

          <ng-container matColumnDef="cadenaFin">
            <th mat-header-cell *matHeaderCellDef>Fin</th>
            <td mat-cell *matCellDef="let el"><span class="ap-date">{{ el.cadenaFin }}</span></td>
          </ng-container>

          <ng-container matColumnDef="motivo">
            <th mat-header-cell *matHeaderCellDef>Motivo</th>
            <td mat-cell *matCellDef="let el">{{ el.motivo || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="cadenaFechaSolicitud">
            <th mat-header-cell *matHeaderCellDef>Solicitud</th>
            <td mat-cell *matCellDef="let el"><span class="ap-date">{{ el.cadenaFechaSolicitud }}</span></td>
          </ng-container>

          <ng-container matColumnDef="nombreEstado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let el">
              <span class="ap-estado-badge"
                    [class.ap-estado-badge--ok]="el.nombreEstado === 'Aprobada'"
                    [class.ap-estado-badge--warn]="el.nombreEstado !== 'Aprobada'">
                {{ el.nombreEstado }}
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsByEmployee"></tr>
          <tr mat-row *matRowDef="let r; columns: displayedColumnsByEmployee;" class="ap-row"></tr>
        </table>
      </div>
    </div>

  </ng-container>

</div>

<!-- ── Menús ─────────────────────────────────────────────────── -->
<mat-menu #menuSolicitados="matMenu">
  <button mat-menu-item (click)="editar()">
    <mat-icon>edit</mat-icon><span>Editar</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item class="ap-action-danger" (click)="eliminar()">
    <mat-icon>delete</mat-icon><span>Borrar</span>
  </button>
</mat-menu>

<mat-menu #menuAprobados="matMenu">
  <button mat-menu-item (click)="editar()">
    <mat-icon>edit</mat-icon><span>Editar</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item class="ap-action-danger" (click)="eliminar()">
    <mat-icon>delete</mat-icon><span>Borrar</span>
  </button>
</mat-menu>
